angular.module('impactx.login').controller('SLoginController', [
    '$scope',
    'LoginService',
    'cookieService',
    'BrowserSettings',
    '$mdDialog',
    'AppConfiguration',
    'LegalLinking',
    'TranslationService',
    'MinWidthService',
    SLoginController]);

function SLoginController($scope, LoginService, cookieService, BrowserSettings, $mdDialog, AppConfiguration, LegalLinking, TranslationService, MinWidthService) {
    cookieService.removeCookie("loginPage");
    $scope.currentYear = AppConfiguration.get('copyRightYear');
    $scope.loginAllowed = BrowserSettings.cookiesEnabled;
    LoginService.prepareLogin(dialogFunction);
    $scope.translations = TranslationService;

    $scope.imprintURL = AppConfiguration.get('imprintURL');
    $scope.privacyPolicy = AppConfiguration.get('privacyPolicy');
    $scope.generalTerms = AppConfiguration.get('generalTerms');
    $scope.logoUrl = AppConfiguration.get('loginPageLogoUrl');
    $scope.backgroundImage = AppConfiguration.get('loginPageBackgroundUrl');
    $scope.removeCopyRight = AppConfiguration.get('removeCopyRight');

    $scope.openDialog = function (ev, link, title) {
        LegalLinking.openDialog(ev, link, title);
    };
    MinWidthService.setSpecialMinWidthForDialog($scope, 0);

    function dialogFunction() {
        $mdDialog.show({
            multiple: true,
            templateUrl: 'modules/login/templates/s-login.tmpl.html',
            controller: 'LoginDialogController',
            controllerAs: "loginCtrl",
            bindToController: true,
            clickOutsideToClose: false,
            escapeToClose: false,
            fullscreen: false,
            onComplete: function (scope) {
                scope.dialogData.password.$setValidity("cookiesDisabled", BrowserSettings.cookiesEnabled);
                scope.isLoaded = true;
            }
        });
    }
}